export const enum MENU_POINT_TYPES {
  COMMAND = 'COMMAND',
  LINK = 'LINK',
  HEADER = 'HEADER',
  DIVIDER = 'DIVIDER',
  GROUP = 'GROUP',
  ACTION = 'ACTION',
}

export const enum OBJECT_TYPES_FOR_MENU_POINT_LABEL {
  FORM = 'FORM',
  GANTT_CHART = 'GANTT CHART',
  LIST_CONTROL = 'LIST CONTROL',
  VIEW = 'VIEW',
  WINDOW = 'WINDOW',
}

export const enum OBJECT_TYPES_FOR_MENU_POINT_VALUE {
  GANTT_CHART = 'GANTT_CHART',
  VIEW = 'VIEW',
  WINDOW = 'WINDOW',
}

export const enum CONTEXT_MENU_TABS {
  MENU_POINT = 0,
  DYNAMIC_VARIABLES = 1,
  STATIC_VARIABLES = 2,
}

export const enum ELEMENT_TYPE_CONTEXT_MENU {
  CONTEXT = 'CONTEXT',
  POINT = 'POINT',
  VARIABLE = 'VARIABLE',
}
